import { ref } from 'vue';

const employeeFlextimeProfilesHandling = () => {
    const employeeFlextimeProfiles_error = ref(null);
    const employeeFlextimeProfiles = ref(null);

    const attachFlextimeProfile =  async (employeeId, flextimeProfileId, startAt) => {

        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json',
                'accept': 'application/json',
            },
            body: JSON.stringify({
                employee_id: employeeId,
                flextimeProfile_id: flextimeProfileId,
                start_at: startAt
            })
        };

        try {
            const response = await fetch('/api/employees/' + employeeId + '/attachflextimeprofile', requestOptions);
            //console.log(requestOptions);
            if (!response.ok) {
                //console.log('composable response not ok: ' , response.status + ' - ' + response.statusText);
                employeeFlextimeProfiles_error.value = response.status + ' - ' + response.statusText;
            }
            const data = await response.json();
            //console.log('composable data: ' , data);
            return data;

        } catch (err) {
            employeeFlextimeProfiles_error.value = err.message;
            console.log('composable error: ' ,err.message);
        }

        //console.log('composable gelangte hinter try catch');
    }
    
    return {  employeeFlextimeProfiles_error, attachFlextimeProfile };

};

    function getCookie(name) {
        const value = `; ${document.cookie}`;       
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };


export default employeeFlextimeProfilesHandling;
